import { MultiTermFilter } from '@opendoor/tessellation';

interface WorkOrderTypeFilterProps {
  field: string;
  title?: string;
}

const WorkOrderTypeFilter = ({
  field = 'kind',
  title = 'Work Order Type',
}: WorkOrderTypeFilterProps) => {
  let options: string[] = [
    'HOA_VIOLATION',
    'RESALE',
    'RENOVATION',
    'INCIDENT',
    'INSURED',
    'SOLD',
    'REWORK',
    'LISTED',
    'LENDER_REQUIRED',
    'LWOD',
    'FEEDBACK',
  ];

  return <MultiTermFilter title={title} field={field} options={options} />;
};

export default WorkOrderTypeFilter;
